import React from "react";

function PaymentReturn() {
  return <div>PaymentReturn</div>;
}

export default PaymentReturn;
